/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
// eslint-disable-next-line import/no-cycle
import BiddingInfoModal from '../../molecules/bidding_info_modal';
import {
  BiddingContract,
  BiddingInfoTypes,
  FollowupTypes,
} from '../../../store/modules/bidding_store/types';
import FollowupBiddingModal from '../followup_bidding_modal';
import ContractBiddingModal from '../contract_bidding_modal';

interface BiddingInfoProps {
  bidding_info: BiddingInfoTypes[];
  followup: FollowupTypes[];
  contracts: BiddingContract[];
}

const BiddingInfoDropdown: React.FC<BiddingInfoProps> = ({ bidding_info, followup, contracts }) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showModalFollowup, setShowModalFollowup] = useState<boolean>(false);
  const [showModalContracts, setShowModalContracts] = useState<boolean>(false);
  const [TypeName, setTypeName] = useState<string>('');
  const [list, setList] = useState<any>({});

  const toggleBiddingInfoContent = (type: string, list_file: any) => {
    setTypeName(type);
    setList(list_file);
    setShowModal(true);
  };

  const esclarecimentoItems = bidding_info.filter((item) => item.type_id === 1);
  const impugnacaoItems = bidding_info.filter((item) => item.type_id === 2);
  const avisoItems = bidding_info.filter((item) => item.type_id === 3);
  const recursoItems = bidding_info.filter((item) => item.type_id === 4);
  const diligenciaItems = bidding_info.filter((item) => item.type_id === 5);

  return (
    <>
      <Dropdown className="mr-1 mb-1">
        <Dropdown.Toggle
          id="dropdown-basic"
          size="sm"
          style={{ backgroundColor: '#01366E', borderColor: '#01366E', color: '#fff' }}
        >
          Ver arquivos (
          {(bidding_info?.length || 0) + (followup?.length || 0) + (contracts?.length || 0)})
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {followup?.length > 0 && (
            <>
              <Dropdown.Item onClick={() => setShowModalFollowup(true)}>
                Acompanhamentos ({followup?.length})
              </Dropdown.Item>
              <Dropdown.Divider />
            </>
          )}

          {contracts?.length > 0 && (
            <>
              <Dropdown.Item onClick={() => setShowModalContracts(true)}>
                Contratos ({contracts.length})
              </Dropdown.Item>
              <Dropdown.Divider />
            </>
          )}
          <Dropdown.Item onClick={() => toggleBiddingInfoContent('Avisos', avisoItems)}>
            Avisos ({avisoItems?.length})
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item
            onClick={() => toggleBiddingInfoContent('Esclarecimentos', esclarecimentoItems)}
          >
            Esclarecimentos ({esclarecimentoItems?.length})
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item onClick={() => toggleBiddingInfoContent('Impugnações', impugnacaoItems)}>
            Impugnações ({impugnacaoItems?.length})
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item onClick={() => toggleBiddingInfoContent('Recursos', recursoItems)}>
            Recursos ({recursoItems?.length})
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item onClick={() => toggleBiddingInfoContent('Diligências', diligenciaItems)}>
            Diligências ({diligenciaItems?.length})
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      <BiddingInfoModal
        setShowModal={setShowModal}
        showModal={showModal}
        typeName={TypeName}
        bidding_info={list}
      />
      <FollowupBiddingModal
        showModalFollowup={showModalFollowup}
        setShowModalFollowup={setShowModalFollowup}
        followup={followup}
      />
      <ContractBiddingModal
        showModalContracts={showModalContracts}
        setShowModalContracts={setShowModalContracts}
        contracts={contracts}
      />
    </>
  );
};

export default BiddingInfoDropdown;
